import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

export function AddNovelPage() {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!url.trim()) {
      setError('請輸入小說網址');
      return;
    }

    // 支援多個來源
    const supportedSources = ['crxs.me', 'czbooks.net', 'alicesw.com', 'alicesw.tw', 'hjwzw.com'];
    const isSupported = supportedSources.some(source => url.includes(source));
    if (!isSupported) {
      setError('請輸入支援的小說網址 (crxs.me、czbooks.net、alicesw.com 或 hjwzw.com)');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const novel = await api.createNovel(url);
      navigate(`/novels/${novel.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : '新增失敗');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">新增小說</h1>
        <p className="text-gray-600 mt-1">
          輸入小說網址，自動下載並轉換為繁體中文
        </p>
        <p className="text-xs text-gray-500 mt-1">
          支援來源：crxs.me、czbooks.net、alicesw.com、hjwzw.com
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="url" className="block text-sm font-medium text-gray-700 mb-1">
            小說網址
          </label>
          <input
            type="url"
            id="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://tw.hjwzw.com/Book/xxx 或 https://crxs.me/fiction/id-xxx.html"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-shadow"
            disabled={loading}
          />
        </div>

        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 px-4 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              處理中...
            </span>
          ) : (
            '開始下載'
          )}
        </button>

      </form>

      <div className="mt-8 p-4 bg-gray-50 rounded-lg">
        <h3 className="font-medium text-gray-700 mb-2">使用說明</h3>
        <ol className="list-decimal list-inside text-sm text-gray-600 space-y-1">
          <li>前往支援的小說網站找到想要收藏的小說</li>
          <li>複製小說目錄頁的網址</li>
          <li>貼上網址並點擊「開始下載」</li>
          <li>系統會自動下載並轉換為繁體中文</li>
          <li>下載完成後可在「書架」中閱讀</li>
        </ol>
      </div>
    </div>
  );
}
